// src/pages/Arguente/ArguentePage.jsx
import React from 'react';
import ArguenteList from '../../components/Arguente/ArguenteList';
import { Link } from 'react-router-dom';

const ArguentePage = () => {
    return (
        <div>
            <h1>Gestão de Arguentes</h1>
            <Link to="/arguentes/registrar">Registrar Novo Arguente</Link>
            <ArguenteList />
        </div>
    );
};

export default ArguentePage;